import {create} from 'zustand'
import {acionsTypesWrote, Action, Dispatch} from '../../logic/actionsType'
import {IWrote} from '../../../interfaces'

type TWroteState = {
  WroteList?: IWrote[]
  currentPage?: number
  search?: string
  pageSizeC?: number
  totalRecords?: number | undefined
  selectedId?: number | undefined
  WroteListIsFetching?: boolean
  showSeenAllModal?: boolean
}

type State = {
  state: TWroteState
}

const reducer = (
  state: State,
  action: Action<keyof typeof acionsTypesWrote, TWroteState>
): State => {
  switch (action.type) {
    case 'ADD_WROTE_LIST':
      return {state: {...state.state, WroteList: action.payload.WroteList}}
    case 'TOTALRECORD_WROTE_LIST':
      return {state: {...state.state, totalRecords: action.payload.totalRecords}}
    case 'CURRENTTPAGE_WROTE_LIST':
      return {state: {...state.state, currentPage: action.payload.currentPage}}
    case 'PAGESIZE_WROTE_LIST':
      return {state: {...state.state, pageSizeC: action.payload.pageSizeC}}
    case 'SEARCH_WROTE_LIST':
      return {state: {...state.state, search: action.payload.search}}
    case 'SELECTEDID_WROTE_LIST':
      return {state: {...state.state, selectedId: action.payload.selectedId}}
    case 'FETCHING_WORT':
      return {state: {...state.state, WroteListIsFetching: action.payload.WroteListIsFetching}}
    case 'SHOW_SEEN_MODAL':
      return {state: {...state.state, showSeenAllModal: action.payload.showSeenAllModal}}
    default:
      return state
  }
}

export const useWroteStore = create<State & Dispatch<keyof typeof acionsTypesWrote, TWroteState>>(
  (set) => ({
    state: {
      WroteList: [],
      currentPage: 0,
      search: '',
      pageSizeC: 10,
      WroteListIsFetching: false,
      totalRecords: 0,
      selectedId: undefined,
      showSeenAllModal: false,
    },
    dispatch: (action) => {
      set((state: State) => reducer(state, action))
    },
  })
)
